import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './NumberPillModal.module.scss';

class NumberPillModal extends Component {
    componentDidMount() {
        const form = this.props.value;
        this.props.setUpState(
            this.calculateValue(form),
            form,
            this.calculateValueIsBlank(this.props.value)
        );
    }

    componentWillUnmount() {
        this.props.resetFilter();
    }

    getEmptyValues() {
        return {
            value: this.calculateValue({ from: null, to: null }),
            form: {}
        };
    }

    calculateValueIsBlank(formState) {
        const calcVal = this.calculateValue(formState);
        return calcVal.from === null && calcVal.to === null;
    }

    // eslint-disable-next-line class-methods-use-this
    calculateValue(formState) {
        return {
            from: formState.from !== null ? formState.from : null,
            to: formState.to !== null ? formState.to : null,
        };
    }

    render() {
        return (
            <div className={ styles.numberWrapper }>
                <div className={ styles.searchInput }>
                    <input
                        className={ styles.input }
                        type="number"
                        name={ `number-${this.props.filter.title}-searchValue` }
                        valuename="searchValue"
                        placeholder={ `${this.props.filter.title}` }
                        onChange={ (value) => {
                            const parsedValue = parseFloat(value.target.value);
                            this.props.handleUpdate('from', Number.isNaN(parsedValue) ? null : parsedValue);
                        } }
                        value={ this.props.value.from !== null ? this.props.value.from : '' }
                    />
                </div>
                <div className={ styles.searchInput }>
                    <input
                        className={ styles.input }
                        type="number"
                        name={ `number-${this.props.filter.title}-searchValue` }
                        valuename="searchValue"
                        placeholder={ `${this.props.filter.title}` }
                        onChange={ (value) => {
                            const parsedValue = parseFloat(value.target.value);
                            this.props.handleUpdate('to', Number.isNaN(parsedValue) ? null : parsedValue);
                        } }
                        value={ this.props.value.to !== null ? this.props.value.to : '' }
                    />
                </div>
            </div>
        );
    }
}

NumberPillModal.propTypes = {
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.shape({
            from: PropTypes.number,
            to: PropTypes.number,
        })
    }),
    handleUpdate: PropTypes.func.isRequired,
    value: PropTypes.shape({
        from: PropTypes.number,
        to: PropTypes.number,
    }),
    setUpState: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired
};

NumberPillModal.defaultProps = {
    filter: {
        value: ''
    },
    value: ''
};

export default NumberPillModal;
